module.exports = __webpack_public_path__ + "static/img/banner1View.b81b3916.jpg";